module.exports = __webpack_public_path__ + "img/violet-soldier.bf33203f.png";